"use client";

import { useContext } from "react";
import { Alert, Slide, Snackbar } from "@mui/material";
import MessageContext from "@/context/MessageProvider";

const TransitionLeft = (props) => {
  return <Slide {...props} direction="right"/>;
};

const MessageSnackbar = (props) => {
  const { message, setMessage } = useContext(MessageContext)!;

  const handleCloseMessage = () => {
    setMessage({ isOpen: false, content: "" });
  };

  return <Snackbar
    open={message.isOpen}
    onClose={handleCloseMessage}
    autoHideDuration={6000}
    TransitionComponent={TransitionLeft}
    key={"right"}
  >
    <Alert sx={{ width: "100%" }} severity={message.severity}>
      {message.content}
    </Alert>
  </Snackbar>;
};

export default MessageSnackbar;
